/** Events die aantonen dat de gebruiker zelf scrolt; vanaf dan blijven we eraf. */
const USER_SCROLL_INTENT_EVENTS = ['wheel', 'touchmove', 'keydown'] as const;

/**
 * Houdt een net opengeklapte sectie (een zoektocht in een paneel) in beeld terwijl
 * ze groeit: eerst de laadmelding, dan de treffers en de pager. Bij elke groei
 * scrolt de dichtstbijzijnde scrollcontainer net genoeg (`block: 'nearest'`) om de
 * sectie te tonen, gedurende een kort venster. Zonder dit gebeurde er na een klik
 * schijnbaar niets: de inhoud verscheen onder de rand van het paneel.
 *
 * Scrolt de gebruiker zelf (wiel, touch, toets), dan stopt het meteen. Geeft een
 * stop-functie terug (aanroepen bij dichtklappen of vernietigen).
 */
export function hdRevealWhileGrowing(element: HTMLElement, windowMs = 1500): () => void {
  let stopped = false;
  const reveal = () => {
    if (!stopped) element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };
  const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(() => reveal());
  observer?.observe(element);
  const frame = requestAnimationFrame(reveal);
  const stop = () => {
    if (stopped) return;
    stopped = true;
    observer?.disconnect();
    cancelAnimationFrame(frame);
    clearTimeout(timeout);
    for (const event of USER_SCROLL_INTENT_EVENTS) window.removeEventListener(event, stop, true);
  };
  const timeout = setTimeout(stop, windowMs);
  for (const event of USER_SCROLL_INTENT_EVENTS) window.addEventListener(event, stop, { capture: true, passive: true });
  return stop;
}
